import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Col,
  Form,
  Icon,
  InputNumber,
  message,
  Row,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "./WizardConfig.css";

import { postDocumentsConfig } from "../../api/requests";
import { logout, setAppSettings } from "../../reducers/user/actions";

class DocumentsConfigForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      configData: {},
      isLoadingData: false,
      isLoading: false,
      drugDosageSettingsKeys: [],
      drugDosageSettingsValues: {},
      randomizationData: null,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.drugManagementData.is_configured !==
      this.props.drugManagementData.is_configured
    ) {
      this.setData();
    }
  }

  setData = () => {
    this.setState({
      documentsConfigData: this.props.documentsConfigData,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      errorMessage: null,
    });
    this.props.form.validateFields(async (err, values) => {
      const data = { ...values };

      try {
        await postDocumentsConfig(data);
        message.success(this.props.i18n.t("Saved"));
        this.props.setAppSettings();
        this.props.onSubmit();
      } catch (e) {
        this.setState({
          errorMessage: JSON.stringify(get(e, "response.data.errors")),
        });
        message.error(this.props.i18n.t("Error"));
        console.log(e);
      }
    });
  };

  render() {
    const {
      documentsConfigData,
      isLoading,
      isLoadingData,
      errorMessage,
    } = this.state;
    const { randomizationData, isDisabled } = this.props;
    const { getFieldDecorator } = this.props.form;
    const isRandomizeConfig =
      get(randomizationData, "treatment_groups", []).length > 0;
    const isEditable = isRandomizeConfig;

    return (
      <div className={classes.formWrapper}>
        <h3 className="headline-default">{this.props.i18n.t("NamespaceWizardConfig:Documents Config")} </h3>

        {!isLoadingData ? (
          <Form onSubmit={this.handleSubmit}>
            <Row gutter={8}>
              <Col sm={24}>
                {!isRandomizeConfig && (
                  <Alert
                    type="warning"
                    message={this.props.i18n.t(
                      "NamespaceWizardConfig:Please fill Randomization Config first"
                    )}
                  />
                )}
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={24}>
                <b>{this.props.i18n.t("Document expiration warning days")}</b>
                <div style={{ margin: "0 0 30px", width: "250px" }}>
                  {getFieldDecorator("document_expiration_warning_days", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(
                      documentsConfigData,
                      "document_expiration_warning_days"
                    ),
                  })(<InputNumber disabled={!isEditable || isDisabled} />)}
                </div>
              </Col>
            </Row>

            <Row gutter={8}>
              {errorMessage && (
                <Col span={24}>
                  <Alert message={errorMessage} type="error" />
                </Col>
              )}
              <Col span={24}>
                <Button
                  disabled={!isEditable || isDisabled}
                  type="primary"
                  size="large"
                  htmlType="submit"
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Icon type="loading" />
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { setAppSettings, logout };

export default Form.create({ name: "DocumentsConfigForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DocumentsConfigForm))
);



// WEBPACK FOOTER //
// ./src/containers/WizardConfig/DocumentsConfigForm.js